import React from "react";
import { Box, Flex, Heading } from "@chakra-ui/core";

/** This is the top part of the dashboard body
 * main content. It will mostly hold the name of the function
 * in which the user is currently in
 */

const DashboardBodyHeaderMockup = () => {
  return (
    <>
      <Box width="100%" py="15px" background="#333351" p={0}>
        <Flex align="center" justify="center" w="100%">
          <Box pt="26px" maxWidth="800px" w="100%" h="100%">
            <Box
              background="white"
              borderTopRightRadius="5px"
              borderTopLeftRadius="5px"
              height="60px"
              m="auto"
              mx="10px"
              p="10px"
            >
            <Heading style={{textTransform:"capitalize"}} textAlign="center" color="primary.500" as="h3" size="lg">
              Orders
            </Heading>
            </Box>
          </Box>
        </Flex>
      </Box>
    </>
  );
};

export default DashboardBodyHeaderMockup;
